(function () {

  function initAnimations(container = document) {

    const elements = container.querySelectorAll(
      '[data-animate]:not([data-animation-ready])'
    );

    if (!elements.length) return;

    /* Fallback for older browsers */
    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) return;

          const element = entry.target;

          /* Optional delay */
          const delay = element.dataset.delay;

          if (delay) {
            element.style.setProperty(
              '--animation-delay',
              `${delay}ms`
            );
          }

          element.classList.add('is-visible');

          observerInstance.unobserve(element);

        });

      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }
    );


    elements.forEach((element) => {

      element.setAttribute(
        'data-animation-ready',
        'true'
      );

      observer.observe(element);

    });

  }


  /* Normal page load */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initAnimations()
    );

  } else {

    initAnimations();

  }


  /* Shopify Theme Editor support */
  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAnimations(event.target);

    }
  );

})();